/* eslint-disable @typescript-eslint/naming-convention*/
import { EProcessType } from '@pc/common';
import { TravelerType } from '../../../../shared/models/traveler.interface';

export interface ProductInfoInterface {
  Id: number;
  Name: string;
  MaxExposure: number;
  MaxExposurePolicyEndDate: string;
  IsAnnual: boolean;
  IsDomestic: boolean;
  HasCoupon: boolean;
  MaxPolicyPeriodDays: number;
  AmtTripDurations: IAMTTripDurationResponse[];
  DaysUntilLastStartDate?: number;
}

interface IAMTTripDurationResponse {
  tripDurationDisplayValue: string;
  tripDurationID: number;
  isDefault: boolean;
}

export interface TravelerShort {
  participantNum: number;
  age: number;
  type: TravelerType;
  bornDate: Date;
}

export interface CalendarRestrictionsResponse {
  statusCode: number;
  status: number;
  data: ProductInfoInterface[];
  error: string;
}

export enum CalendarErrorType {
  ANNUAL_TRAVELER_COUNT_EXCEEDED = 'ANNUAL_TRAVELER_COUNT_EXCEEDED',
  ANNUAL_TRAVELER_AGE_EXCEEDED = 'ANNUAL_TRAVELER_AGE_EXCEEDED',
  NO_PRODUCTS_AVAILABLE = 'NO_PRODUCTS_AVAILABLE',
  SUCCESS = 'SUCCESS'
}

export const CalendarErrorsToLabels = {
  [CalendarErrorType.ANNUAL_TRAVELER_COUNT_EXCEEDED]: 'annualTravelerCountExceeded',
  [CalendarErrorType.ANNUAL_TRAVELER_AGE_EXCEEDED]: 'annualTravelerAgeExceeded',
  [CalendarErrorType.NO_PRODUCTS_AVAILABLE]: 'noProductsAvailable'
} as const;

export interface CalendarRestrictionsRequest {
  travelers: TravelerShort[];
  countryListId: number[];
  processType: EProcessType;
  policyType: PolicyDateType;
  organizationId: string | null;
  agentSaleNumberId: string | null;
}

export enum PolicyDateType {
  NONE = 0,
  DAILY = 1,
  YEARLY = 2
}

export const CalendarRestrictionsMock = {
  statusCode: 200,
  status: 0,
  data: {
    calendarRestrictions: [
      {
        daysUntilLastStartDate: 365,
        maximumPolicyDuration: 180,
        policyType: 1
      }
    ],
    calendarErrorType: 3
  },
  error: '',
  error_type: null,
  end_Proc: null
};
